import React from "react";
import { Intersect, PRFN } from "../../assets/images";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { EcobookProfile } from "../../types";

type ProfileHeaderProps = {
  userDetails?: EcobookProfile;
};
const ProfileHeader: React.FC<ProfileHeaderProps> = ({ userDetails }) => {
  // const userDetails = useSelector((state: EcobookProfile) => state);

  let coverImage: string | null = "";

  if (
    userDetails?.ecobookProfile &&
    userDetails?.ecobookProfile.coverImage &&
    userDetails?.ecobookProfile.coverImage !== null
  ) {
    const _coverImage = userDetails.ecobookProfile.coverImage;

    if (_coverImage !== null && _coverImage !== undefined) {
      coverImage = _coverImage;
    }
  }

  return (
    <>
      {coverImage && coverImage ? (
        <div className="w-full relative h-[245px] overflow-hidden">
          <img
            alt=""
            src={ipfsGatewayImage(coverImage!)}
            className="w-full object-cover h-full object-center"
          />
        </div>
      ) : (
        <div className="bg-midGreen relative rounded p-12 h-[245px] w-full">
          <h1 className="font-Jakarta font-bold text-white text-[50px] w-[25%]">
            My Profile
          </h1>
          <img src={Intersect} alt="" className="top-0 left-20 absolute" />
          <img src={PRFN} alt="" className="right-8 bottom-0 absolute" />
          <img src={Intersect} alt="" className="bottom-0 right-8 absolute" />
        </div>
      )}
    </>
  );
};

export default ProfileHeader;
